{
 "meta": {
  "generated": "2026-09-16T01:19:48.098Z",
  "tool": "tools/build-registry.mjs",
  "cardAspect": 1.3984375,
  "cellsPerFace": 9
 },
 "sets": [
  {
   "code": "SET5",
   "name": "5원소",
   "total": 225,
   "slotBase": null
  }
 ],
 "cards": [
  {
   "id": "FIRE_001",
   "set": "SET5",
   "no": 1,
   "dex": 1,
   "rank": 0,
   "name": "숯가시",
   "slot": 1
  },
  {
   "id": "FIRE_002",
   "set": "SET5",
   "no": 2,
   "dex": 2,
   "rank": 0,
   "name": "불가시",
   "slot": 2
  },
  {
   "id": "FIRE_003",
   "set": "SET5",
   "no": 3,
   "dex": 136,
   "rank": 1,
   "name": "화산호",
   "slot": 3
  },
  {
   "id": "FIRE_004",
   "set": "SET5",
   "no": 4,
   "dex": 3,
   "rank": 0,
   "name": "재파기",
   "slot": 4
  },
  {
   "id": "FIRE_005",
   "set": "SET5",
   "no": 5,
   "dex": 4,
   "rank": 0,
   "name": "열파기",
   "slot": 5
  },
  {
   "id": "FIRE_006",
   "set": "SET5",
   "no": 6,
   "dex": 137,
   "rank": 1,
   "name": "마그파기",
   "slot": 6
  },
  {
   "id": "FIRE_007",
   "set": "SET5",
   "no": 7,
   "dex": 5,
   "rank": 0,
   "name": "김개굴",
   "slot": 7
  },
  {
   "id": "FIRE_008",
   "set": "SET5",
   "no": 8,
   "dex": 6,
   "rank": 0,
   "name": "끓개굴",
   "slot": 8
  },
  {
   "id": "FIRE_009",
   "set": "SET5",
   "no": 9,
   "dex": 138,
   "rank": 1,
   "name": "유황두꺼비",
   "slot": 9
  },
  {
   "id": "FIRE_010",
   "set": "SET5",
   "no": 10,
   "dex": 7,
   "rank": 0,
   "name": "숯집게",
   "slot": 10
  },
  {
   "id": "FIRE_011",
   "set": "SET5",
   "no": 11,
   "dex": 8,
   "rank": 0,
   "name": "화로게",
   "slot": 11
  },
  {
   "id": "FIRE_012",
   "set": "SET5",
   "no": 12,
   "dex": 139,
   "rank": 1,
   "name": "용광게",
   "slot": 12
  },
  {
   "id": "FIRE_013",
   "set": "SET5",
   "no": 13,
   "dex": 9,
   "rank": 0,
   "name": "아지랑",
   "slot": 13
  },
  {
   "id": "FIRE_014",
   "set": "SET5",
   "no": 14,
   "dex": 10,
   "rank": 0,
   "name": "열랑이",
   "slot": 14
  },
  {
   "id": "FIRE_015",
   "set": "SET5",
   "no": 15,
   "dex": 140,
   "rank": 1,
   "name": "신기루레온",
   "slot": 15
  },
  {
   "id": "FIRE_016",
   "set": "SET5",
   "no": 16,
   "dex": 11,
   "rank": 0,
   "name": "재굼벵",
   "slot": 16
  },
  {
   "id": "FIRE_017",
   "set": "SET5",
   "no": 17,
   "dex": 12,
   "rank": 0,
   "name": "숯번데",
   "slot": 17
  },
  {
   "id": "FIRE_018",
   "set": "SET5",
   "no": 18,
   "dex": 141,
   "rank": 1,
   "name": "용암뿔",
   "slot": 18
  },
  {
   "id": "FIRE_019",
   "set": "SET5",
   "no": 19,
   "dex": 13,
   "rank": 0,
   "name": "재양이",
   "slot": 19
  },
  {
   "id": "FIRE_020",
   "set": "SET5",
   "no": 20,
   "dex": 14,
   "rank": 0,
   "name": "벼랑양",
   "slot": 20
  },
  {
   "id": "FIRE_021",
   "set": "SET5",
   "no": 21,
   "dex": 142,
   "rank": 1,
   "name": "흑요왕양",
   "slot": 21
  },
  {
   "id": "FIRE_022",
   "set": "SET5",
   "no": 22,
   "dex": 15,
   "rank": 0,
   "name": "잉걸박",
   "slot": 22
  },
  {
   "id": "FIRE_023",
   "set": "SET5",
   "no": 23,
   "dex": 16,
   "rank": 0,
   "name": "열풍박",
   "slot": 23
  },
  {
   "id": "FIRE_024",
   "set": "SET5",
   "no": 24,
   "dex": 143,
   "rank": 1,
   "name": "횃불박쥐",
   "slot": 24
  },
  {
   "id": "FIRE_025",
   "set": "SET5",
   "no": 25,
   "dex": 17,
   "rank": 0,
   "name": "뜨끈발",
   "slot": 25
  },
  {
   "id": "FIRE_026",
   "set": "SET5",
   "no": 26,
   "dex": 18,
   "rank": 0,
   "name": "용암발",
   "slot": 26
  },
  {
   "id": "FIRE_027",
   "set": "SET5",
   "no": 27,
   "dex": 144,
   "rank": 1,
   "name": "화산켄",
   "slot": 27
  },
  {
   "id": "FIRE_028",
   "set": "SET5",
   "no": 28,
   "dex": 19,
   "rank": 0,
   "name": "연기꼬리",
   "slot": 28
  },
  {
   "id": "FIRE_029",
   "set": "SET5",
   "no": 29,
   "dex": 145,
   "rank": 1,
   "name": "매연꼬리",
   "slot": 29
  },
  {
   "id": "FIRE_030",
   "set": "SET5",
   "no": 30,
   "dex": 20,
   "rank": 0,
   "name": "숯늘보",
   "slot": 30
  },
  {
   "id": "FIRE_031",
   "set": "SET5",
   "no": 31,
   "dex": 146,
   "rank": 1,
   "name": "잉걸늘보",
   "slot": 31
  },
  {
   "id": "FIRE_032",
   "set": "SET5",
   "no": 32,
   "dex": 21,
   "rank": 0,
   "name": "성냥벌",
   "slot": 32
  },
  {
   "id": "FIRE_033",
   "set": "SET5",
   "no": 33,
   "dex": 147,
   "rank": 1,
   "name": "화약벌",
   "slot": 33
  },
  {
   "id": "FIRE_034",
   "set": "SET5",
   "no": 34,
   "dex": 22,
   "rank": 0,
   "name": "용암해파리",
   "slot": 34
  },
  {
   "id": "FIRE_035",
   "set": "SET5",
   "no": 35,
   "dex": 23,
   "rank": 0,
   "name": "열기전갈",
   "slot": 35
  },
  {
   "id": "FIRE_036",
   "set": "SET5",
   "no": 36,
   "dex": 24,
   "rank": 0,
   "name": "유황사마귀",
   "slot": 36
  },
  {
   "id": "FIRE_037",
   "set": "SET5",
   "no": 37,
   "dex": 25,
   "rank": 0,
   "name": "재거미",
   "slot": 37
  },
  {
   "id": "FIRE_038",
   "set": "SET5",
   "no": 38,
   "dex": 26,
   "rank": 0,
   "name": "용암아딜로",
   "slot": 38
  },
  {
   "id": "FIRE_039",
   "set": "SET5",
   "no": 39,
   "dex": 27,
   "rank": 0,
   "name": "온천바라",
   "slot": 39
  },
  {
   "id": "FIRE_040",
   "set": "SET5",
   "no": 40,
   "dex": 196,
   "rank": 2,
   "name": "숯가시",
   "slot": 40
  },
  {
   "id": "FIRE_041",
   "set": "SET5",
   "no": 41,
   "dex": 197,
   "rank": 2,
   "name": "불가시",
   "slot": 41
  },
  {
   "id": "FIRE_042",
   "set": "SET5",
   "no": 42,
   "dex": 198,
   "rank": 2,
   "name": "화산호",
   "slot": 42
  },
  {
   "id": "FIRE_043",
   "set": "SET5",
   "no": 43,
   "dex": 199,
   "rank": 2,
   "name": "흑요왕양",
   "slot": 43
  },
  {
   "id": "FIRE_044",
   "set": "SET5",
   "no": 44,
   "dex": 200,
   "rank": 2,
   "name": "온천바라",
   "slot": 44
  },
  {
   "id": "FIRE_045",
   "set": "SET5",
   "no": 45,
   "dex": 221,
   "rank": 3,
   "name": "화산호",
   "slot": 45
  },
  {
   "id": "WATER_001",
   "set": "SET5",
   "no": 46,
   "dex": null,
   "rank": 0,
   "name": "방울치",
   "slot": 46
  },
  {
   "id": "WATER_002",
   "set": "SET5",
   "no": 47,
   "dex": 29,
   "rank": 0,
   "name": "물결치",
   "slot": 47
  },
  {
   "id": "WATER_003",
   "set": "SET5",
   "no": 48,
   "dex": 148,
   "rank": 1,
   "name": "심해갑어",
   "slot": 48
  },
  {
   "id": "WATER_004",
   "set": "SET5",
   "no": 49,
   "dex": 30,
   "rank": 0,
   "name": "물장이",
   "slot": 49
  },
  {
   "id": "WATER_005",
   "set": "SET5",
   "no": 50,
   "dex": 31,
   "rank": 0,
   "name": "논장군",
   "slot": 50
  },
  {
   "id": "WATER_006",
   "set": "SET5",
   "no": 51,
   "dex": 149,
   "rank": 1,
   "name": "호수장군",
   "slot": 51
  },
  {
   "id": "WATER_007",
   "set": "SET5",
   "no": 52,
   "dex": 32,
   "rank": 0,
   "name": "물하몽",
   "slot": 52
  },
  {
   "id": "WATER_008",
   "set": "SET5",
   "no": 53,
   "dex": 33,
   "rank": 0,
   "name": "강하몽",
   "slot": 53
  },
  {
   "id": "WATER_009",
   "set": "SET5",
   "no": 54,
   "dex": 150,
   "rank": 1,
   "name": "범람하마",
   "slot": 54
  },
  {
   "id": "WATER_010",
   "set": "SET5",
   "no": 55,
   "dex": 34,
   "rank": 0,
   "name": "꼴뚜",
   "slot": 55
  },
  {
   "id": "WATER_011",
   "set": "SET5",
   "no": 56,
   "dex": 35,
   "rank": 0,
   "name": "먹징어",
   "slot": 56
  },
  {
   "id": "WATER_012",
   "set": "SET5",
   "no": 57,
   "dex": 151,
   "rank": 1,
   "name": "심연징",
   "slot": 57
  },
  {
   "id": "WATER_013",
   "set": "SET5",
   "no": 58,
   "dex": 36,
   "rank": 0,
   "name": "톡새우",
   "slot": 58
  },
  {
   "id": "WATER_014",
   "set": "SET5",
   "no": 59,
   "dex": 37,
   "rank": 0,
   "name": "펀치가재",
   "slot": 59
  },
  {
   "id": "WATER_015",
   "set": "SET5",
   "no": 60,
   "dex": 152,
   "rank": 1,
   "name": "소닉가재",
   "slot": 60
  },
  {
   "id": "WATER_016",
   "set": "SET5",
   "no": 61,
   "dex": 38,
   "rank": 0,
   "name": "물송이",
   "slot": 61
  },
  {
   "id": "WATER_017",
   "set": "SET5",
   "no": 62,
   "dex": 39,
   "rank": 0,
   "name": "여울소",
   "slot": 62
  },
  {
   "id": "WATER_018",
   "set": "SET5",
   "no": 63,
   "dex": 153,
   "rank": 1,
   "name": "급류왕소",
   "slot": 63
  },
  {
   "id": "WATER_019",
   "set": "SET5",
   "no": 64,
   "dex": 40,
   "rank": 0,
   "name": "꼬물치",
   "slot": 64
  },
  {
   "id": "WATER_020",
   "set": "SET5",
   "no": 65,
   "dex": 41,
   "rank": 0,
   "name": "곰치",
   "slot": 65
  },
  {
   "id": "WATER_021",
   "set": "SET5",
   "no": 66,
   "dex": 154,
   "rank": 1,
   "name": "심연곰치",
   "slot": 66
  },
  {
   "id": "WATER_022",
   "set": "SET5",
   "no": 67,
   "dex": 42,
   "rank": 0,
   "name": "방울거미",
   "slot": 67
  },
  {
   "id": "WATER_023",
   "set": "SET5",
   "no": 68,
   "dex": 43,
   "rank": 0,
   "name": "잠수거미",
   "slot": 68
  },
  {
   "id": "WATER_024",
   "set": "SET5",
   "no": 69,
   "dex": 155,
   "rank": 1,
   "name": "심수거미",
   "slot": 69
  },
  {
   "id": "WATER_025",
   "set": "SET5",
   "no": 70,
   "dex": 44,
   "rank": 0,
   "name": "납작치",
   "slot": 70
  },
  {
   "id": "WATER_026",
   "set": "SET5",
   "no": 71,
   "dex": 45,
   "rank": 0,
   "name": "모래가자",
   "slot": 71
  },
  {
   "id": "WATER_027",
   "set": "SET5",
   "no": 72,
   "dex": 156,
   "rank": 1,
   "name": "해저광어",
   "slot": 72
  },
  {
   "id": "WATER_028",
   "set": "SET5",
   "no": 73,
   "dex": 46,
   "rank": 0,
   "name": "물해삼",
   "slot": 73
  },
  {
   "id": "WATER_029",
   "set": "SET5",
   "no": 74,
   "dex": 157,
   "rank": 1,
   "name": "왕해삼",
   "slot": 74
  },
  {
   "id": "WATER_030",
   "set": "SET5",
   "no": 75,
   "dex": 47,
   "rank": 0,
   "name": "둥복치",
   "slot": 75
  },
  {
   "id": "WATER_031",
   "set": "SET5",
   "no": 76,
   "dex": 158,
   "rank": 1,
   "name": "대복치",
   "slot": 76
  },
  {
   "id": "WATER_032",
   "set": "SET5",
   "no": 77,
   "dex": 48,
   "rank": 0,
   "name": "방개",
   "slot": 77
  },
  {
   "id": "WATER_033",
   "set": "SET5",
   "no": 78,
   "dex": 159,
   "rank": 1,
   "name": "물방개장",
   "slot": 78
  },
  {
   "id": "WATER_034",
   "set": "SET5",
   "no": 79,
   "dex": 49,
   "rank": 0,
   "name": "말미잘",
   "slot": 79
  },
  {
   "id": "WATER_035",
   "set": "SET5",
   "no": 80,
   "dex": 50,
   "rank": 0,
   "name": "크릴떼",
   "slot": 80
  },
  {
   "id": "WATER_036",
   "set": "SET5",
   "no": 81,
   "dex": 51,
   "rank": 0,
   "name": "물총치",
   "slot": 81
  },
  {
   "id": "WATER_037",
   "set": "SET5",
   "no": 82,
   "dex": 52,
   "rank": 0,
   "name": "민숭이",
   "slot": 82
  },
  {
   "id": "WATER_038",
   "set": "SET5",
   "no": 83,
   "dex": 53,
   "rank": 0,
   "name": "해면이",
   "slot": 83
  },
  {
   "id": "WATER_039",
   "set": "SET5",
   "no": 84,
   "dex": 54,
   "rank": 0,
   "name": "빙어치",
   "slot": 84
  },
  {
   "id": "WATER_040",
   "set": "SET5",
   "no": 85,
   "dex": 201,
   "rank": 2,
   "name": "방울치",
   "slot": 85
  },
  {
   "id": "WATER_041",
   "set": "SET5",
   "no": 86,
   "dex": 202,
   "rank": 2,
   "name": "물결치",
   "slot": 86
  },
  {
   "id": "WATER_042",
   "set": "SET5",
   "no": 87,
   "dex": 203,
   "rank": 2,
   "name": "심해갑어",
   "slot": 87
  },
  {
   "id": "WATER_043",
   "set": "SET5",
   "no": 88,
   "dex": 204,
   "rank": 2,
   "name": "소닉가재",
   "slot": 88
  },
  {
   "id": "WATER_044",
   "set": "SET5",
   "no": 89,
   "dex": 205,
   "rank": 2,
   "name": "말미잘",
   "slot": 89
  },
  {
   "id": "WATER_045",
   "set": "SET5",
   "no": 90,
   "dex": 222,
   "rank": 3,
   "name": "심해갑어",
   "slot": 90
  },
  {
   "id": "EARTH_001",
   "set": "SET5",
   "no": 91,
   "dex": null,
   "rank": 0,
   "name": "포자리",
   "slot": 91
  },
  {
   "id": "EARTH_002",
   "set": "SET5",
   "no": 92,
   "dex": 56,
   "rank": 0,
   "name": "버섯루",
   "slot": 92
  },
  {
   "id": "EARTH_003",
   "set": "SET5",
   "no": 93,
   "dex": 160,
   "rank": 1,
   "name": "숲왕달",
   "slot": 93
  },
  {
   "id": "EARTH_004",
   "set": "SET5",
   "no": 94,
   "dex": 57,
   "rank": 0,
   "name": "흙오소",
   "slot": 94
  },
  {
   "id": "EARTH_005",
   "set": "SET5",
   "no": 95,
   "dex": 58,
   "rank": 0,
   "name": "굴오소리",
   "slot": 95
  },
  {
   "id": "EARTH_006",
   "set": "SET5",
   "no": 96,
   "dex": 161,
   "rank": 1,
   "name": "바위오소리",
   "slot": 96
  },
  {
   "id": "EARTH_007",
   "set": "SET5",
   "no": 97,
   "dex": 59,
   "rank": 0,
   "name": "땅강이",
   "slot": 97
  },
  {
   "id": "EARTH_008",
   "set": "SET5",
   "no": 98,
   "dex": 60,
   "rank": 0,
   "name": "땅강아지",
   "slot": 98
  },
  {
   "id": "EARTH_009",
   "set": "SET5",
   "no": 99,
   "dex": 162,
   "rank": 1,
   "name": "지진강아지",
   "slot": 99
  },
  {
   "id": "EARTH_010",
   "set": "SET5",
   "no": 100,
   "dex": 61,
   "rank": 0,
   "name": "개미톨",
   "slot": 100
  },
  {
   "id": "EARTH_011",
   "set": "SET5",
   "no": 101,
   "dex": 62,
   "rank": 0,
   "name": "흰개미",
   "slot": 101
  },
  {
   "id": "EARTH_012",
   "set": "SET5",
   "no": 102,
   "dex": 163,
   "rank": 1,
   "name": "개미탑",
   "slot": 102
  },
  {
   "id": "EARTH_013",
   "set": "SET5",
   "no": 103,
   "dex": 63,
   "rank": 0,
   "name": "콩벌레",
   "slot": 103
  },
  {
   "id": "EARTH_014",
   "set": "SET5",
   "no": 104,
   "dex": 64,
   "rank": 0,
   "name": "공벌레",
   "slot": 104
  },
  {
   "id": "EARTH_015",
   "set": "SET5",
   "no": 105,
   "dex": 164,
   "rank": 1,
   "name": "바위공",
   "slot": 105
  },
  {
   "id": "EARTH_016",
   "set": "SET5",
   "no": 106,
   "dex": 65,
   "rank": 0,
   "name": "초원쥐",
   "slot": 106
  },
  {
   "id": "EARTH_017",
   "set": "SET5",
   "no": 107,
   "dex": 66,
   "rank": 0,
   "name": "프레리독",
   "slot": 107
  },
  {
   "id": "EARTH_018",
   "set": "SET5",
   "no": 108,
   "dex": 165,
   "rank": 1,
   "name": "굴군주",
   "slot": 108
  },
  {
   "id": "EARTH_019",
   "set": "SET5",
   "no": 109,
   "dex": 67,
   "rank": 0,
   "name": "가시텐",
   "slot": 109
  },
  {
   "id": "EARTH_020",
   "set": "SET5",
   "no": 110,
   "dex": 68,
   "rank": 0,
   "name": "텐렉",
   "slot": 110
  },
  {
   "id": "EARTH_021",
   "set": "SET5",
   "no": 111,
   "dex": 166,
   "rank": 1,
   "name": "바위텐렉",
   "slot": 111
  },
  {
   "id": "EARTH_022",
   "set": "SET5",
   "no": 112,
   "dex": 69,
   "rank": 0,
   "name": "코돼지",
   "slot": 112
  },
  {
   "id": "EARTH_023",
   "set": "SET5",
   "no": 113,
   "dex": 70,
   "rank": 0,
   "name": "흙돼지",
   "slot": 113
  },
  {
   "id": "EARTH_024",
   "set": "SET5",
   "no": 114,
   "dex": 167,
   "rank": 1,
   "name": "지층돼지",
   "slot": 114
  },
  {
   "id": "EARTH_025",
   "set": "SET5",
   "no": 115,
   "dex": 71,
   "rank": 0,
   "name": "뱃뱃",
   "slot": 115
  },
  {
   "id": "EARTH_026",
   "set": "SET5",
   "no": 116,
   "dex": 72,
   "rank": 0,
   "name": "웜뱃",
   "slot": 116
  },
  {
   "id": "EARTH_027",
   "set": "SET5",
   "no": 117,
   "dex": 168,
   "rank": 1,
   "name": "대륙웜뱃",
   "slot": 117
  },
  {
   "id": "EARTH_028",
   "set": "SET5",
   "no": 118,
   "dex": 73,
   "rank": 0,
   "name": "벌거쥐",
   "slot": 118
  },
  {
   "id": "EARTH_029",
   "set": "SET5",
   "no": 119,
   "dex": 169,
   "rank": 1,
   "name": "두더지쥐왕",
   "slot": 119
  },
  {
   "id": "EARTH_030",
   "set": "SET5",
   "no": 120,
   "dex": 74,
   "rank": 0,
   "name": "문거미",
   "slot": 120
  },
  {
   "id": "EARTH_031",
   "set": "SET5",
   "no": 121,
   "dex": 170,
   "rank": 1,
   "name": "함정거미",
   "slot": 121
  },
  {
   "id": "EARTH_032",
   "set": "SET5",
   "no": 122,
   "dex": 75,
   "rank": 0,
   "name": "캥쥐",
   "slot": 122
  },
  {
   "id": "EARTH_033",
   "set": "SET5",
   "no": 123,
   "dex": 171,
   "rank": 1,
   "name": "사막캥쥐",
   "slot": 123
  },
  {
   "id": "EARTH_034",
   "set": "SET5",
   "no": 124,
   "dex": 76,
   "rank": 0,
   "name": "뿔도마",
   "slot": 124
  },
  {
   "id": "EARTH_035",
   "set": "SET5",
   "no": 125,
   "dex": 77,
   "rank": 0,
   "name": "땅다람",
   "slot": 125
  },
  {
   "id": "EARTH_036",
   "set": "SET5",
   "no": 126,
   "dex": 78,
   "rank": 0,
   "name": "노래기",
   "slot": 126
  },
  {
   "id": "EARTH_037",
   "set": "SET5",
   "no": 127,
   "dex": 79,
   "rank": 0,
   "name": "망보기",
   "slot": 127
  },
  {
   "id": "EARTH_038",
   "set": "SET5",
   "no": 128,
   "dex": 80,
   "rank": 0,
   "name": "똥구리",
   "slot": 128
  },
  {
   "id": "EARTH_039",
   "set": "SET5",
   "no": 129,
   "dex": 81,
   "rank": 0,
   "name": "대벌레",
   "slot": 129
  },
  {
   "id": "EARTH_040",
   "set": "SET5",
   "no": 130,
   "dex": 206,
   "rank": 2,
   "name": "포자리",
   "slot": 130
  },
  {
   "id": "EARTH_041",
   "set": "SET5",
   "no": 131,
   "dex": 207,
   "rank": 2,
   "name": "버섯루",
   "slot": 131
  },
  {
   "id": "EARTH_042",
   "set": "SET5",
   "no": 132,
   "dex": 208,
   "rank": 2,
   "name": "숲왕달",
   "slot": 132
  },
  {
   "id": "EARTH_043",
   "set": "SET5",
   "no": 133,
   "dex": 209,
   "rank": 2,
   "name": "대륙웜뱃",
   "slot": 133
  },
  {
   "id": "EARTH_044",
   "set": "SET5",
   "no": 134,
   "dex": 210,
   "rank": 2,
   "name": "망보기",
   "slot": 134
  },
  {
   "id": "EARTH_045",
   "set": "SET5",
   "no": 135,
   "dex": 223,
   "rank": 3,
   "name": "숲왕달",
   "slot": 135
  },
  {
   "id": "WIND_001",
   "set": "SET5",
   "no": 136,
   "dex": null,
   "rank": 0,
   "name": "붕붕새",
   "slot": 136
  },
  {
   "id": "WIND_002",
   "set": "SET5",
   "no": 137,
   "dex": 83,
   "rank": 0,
   "name": "휙새",
   "slot": 137
  },
  {
   "id": "WIND_003",
   "set": "SET5",
   "no": 138,
   "dex": 172,
   "rank": 1,
   "name": "대풍익",
   "slot": 138
  },
  {
   "id": "WIND_004",
   "set": "SET5",
   "no": 139,
   "dex": 84,
   "rank": 0,
   "name": "톡날치",
   "slot": 139
  },
  {
   "id": "WIND_005",
   "set": "SET5",
   "no": 140,
   "dex": 85,
   "rank": 0,
   "name": "활날치",
   "slot": 140
  },
  {
   "id": "WIND_006",
   "set": "SET5",
   "no": 141,
   "dex": 173,
   "rank": 1,
   "name": "창공날치",
   "slot": 141
  },
  {
   "id": "WIND_007",
   "set": "SET5",
   "no": 142,
   "dex": 86,
   "rank": 0,
   "name": "두룹",
   "slot": 142
  },
  {
   "id": "WIND_008",
   "set": "SET5",
   "no": 143,
   "dex": 87,
   "rank": 0,
   "name": "바람두루",
   "slot": 143
  },
  {
   "id": "WIND_009",
   "set": "SET5",
   "no": 144,
   "dex": 174,
   "rank": 1,
   "name": "천공학",
   "slot": 144
  },
  {
   "id": "WIND_010",
   "set": "SET5",
   "no": 145,
   "dex": 88,
   "rank": 0,
   "name": "실거미",
   "slot": 145
  },
  {
   "id": "WIND_011",
   "set": "SET5",
   "no": 146,
   "dex": 89,
   "rank": 0,
   "name": "낙하거미",
   "slot": 146
  },
  {
   "id": "WIND_012",
   "set": "SET5",
   "no": 147,
   "dex": 175,
   "rank": 1,
   "name": "기류거미",
   "slot": 147
  },
  {
   "id": "WIND_013",
   "set": "SET5",
   "no": 148,
   "dex": 90,
   "rank": 0,
   "name": "꼬리수리",
   "slot": 148
  },
  {
   "id": "WIND_014",
   "set": "SET5",
   "no": 149,
   "dex": 91,
   "rank": 0,
   "name": "물수리",
   "slot": 149
  },
  {
   "id": "WIND_015",
   "set": "SET5",
   "no": 150,
   "dex": 176,
   "rank": 1,
   "name": "폭풍수리",
   "slot": 150
  },
  {
   "id": "WIND_016",
   "set": "SET5",
   "no": 151,
   "dex": 92,
   "rank": 0,
   "name": "도요미",
   "slot": 151
  },
  {
   "id": "WIND_017",
   "set": "SET5",
   "no": 152,
   "dex": 93,
   "rank": 0,
   "name": "철새도요",
   "slot": 152
  },
  {
   "id": "WIND_018",
   "set": "SET5",
   "no": 153,
   "dex": 177,
   "rank": 1,
   "name": "계절풍요",
   "slot": 153
  },
  {
   "id": "WIND_019",
   "set": "SET5",
   "no": 154,
   "dex": 94,
   "rank": 0,
   "name": "키위콩",
   "slot": 154
  },
  {
   "id": "WIND_020",
   "set": "SET5",
   "no": 155,
   "dex": 95,
   "rank": 0,
   "name": "키위새",
   "slot": 155
  },
  {
   "id": "WIND_021",
   "set": "SET5",
   "no": 156,
   "dex": 178,
   "rank": 1,
   "name": "하늘키위",
   "slot": 156
  },
  {
   "id": "WIND_022",
   "set": "SET5",
   "no": 157,
   "dex": 96,
   "rank": 0,
   "name": "꼬맹작",
   "slot": 157
  },
  {
   "id": "WIND_023",
   "set": "SET5",
   "no": 158,
   "dex": 97,
   "rank": 0,
   "name": "공작",
   "slot": 158
  },
  {
   "id": "WIND_024",
   "set": "SET5",
   "no": 159,
   "dex": 179,
   "rank": 1,
   "name": "태풍공작",
   "slot": 159
  },
  {
   "id": "WIND_025",
   "set": "SET5",
   "no": 160,
   "dex": 98,
   "rank": 0,
   "name": "활도마",
   "slot": 160
  },
  {
   "id": "WIND_026",
   "set": "SET5",
   "no": 161,
   "dex": 99,
   "rank": 0,
   "name": "날도마뱀",
   "slot": 161
  },
  {
   "id": "WIND_027",
   "set": "SET5",
   "no": 162,
   "dex": 180,
   "rank": 1,
   "name": "창공도마",
   "slot": 162
  },
  {
   "id": "WIND_028",
   "set": "SET5",
   "no": 163,
   "dex": 100,
   "rank": 0,
   "name": "박각시",
   "slot": 163
  },
  {
   "id": "WIND_029",
   "set": "SET5",
   "no": 164,
   "dex": 181,
   "rank": 1,
   "name": "제트각시",
   "slot": 164
  },
  {
   "id": "WIND_030",
   "set": "SET5",
   "no": 165,
   "dex": 101,
   "rank": 0,
   "name": "톡뚜기",
   "slot": 165
  },
  {
   "id": "WIND_031",
   "set": "SET5",
   "no": 166,
   "dex": 182,
   "rank": 1,
   "name": "회오리뚜기",
   "slot": 166
  },
  {
   "id": "WIND_032",
   "set": "SET5",
   "no": 167,
   "dex": 102,
   "rank": 0,
   "name": "슈가글",
   "slot": 167
  },
  {
   "id": "WIND_033",
   "set": "SET5",
   "no": 168,
   "dex": 183,
   "rank": 1,
   "name": "활공글라이",
   "slot": 168
  },
  {
   "id": "WIND_034",
   "set": "SET5",
   "no": 169,
   "dex": 103,
   "rank": 0,
   "name": "노래새",
   "slot": 169
  },
  {
   "id": "WIND_035",
   "set": "SET5",
   "no": 170,
   "dex": 104,
   "rank": 0,
   "name": "종달이",
   "slot": 170
  },
  {
   "id": "WIND_036",
   "set": "SET5",
   "no": 171,
   "dex": 105,
   "rank": 0,
   "name": "물총새",
   "slot": 171
  },
  {
   "id": "WIND_037",
   "set": "SET5",
   "no": 172,
   "dex": 106,
   "rank": 0,
   "name": "하루살",
   "slot": 172
  },
  {
   "id": "WIND_038",
   "set": "SET5",
   "no": 173,
   "dex": 107,
   "rank": 0,
   "name": "뻐꾹이",
   "slot": 173
  },
  {
   "id": "WIND_039",
   "set": "SET5",
   "no": 174,
   "dex": 108,
   "rank": 0,
   "name": "후투티",
   "slot": 174
  },
  {
   "id": "WIND_040",
   "set": "SET5",
   "no": 175,
   "dex": 211,
   "rank": 2,
   "name": "붕붕새",
   "slot": 175
  },
  {
   "id": "WIND_041",
   "set": "SET5",
   "no": 176,
   "dex": 212,
   "rank": 2,
   "name": "휙새",
   "slot": 176
  },
  {
   "id": "WIND_042",
   "set": "SET5",
   "no": 177,
   "dex": 213,
   "rank": 2,
   "name": "대풍익",
   "slot": 177
  },
  {
   "id": "WIND_043",
   "set": "SET5",
   "no": 178,
   "dex": 214,
   "rank": 2,
   "name": "태풍공작",
   "slot": 178
  },
  {
   "id": "WIND_044",
   "set": "SET5",
   "no": 179,
   "dex": 215,
   "rank": 2,
   "name": "물총새",
   "slot": 179
  },
  {
   "id": "WIND_045",
   "set": "SET5",
   "no": 180,
   "dex": 224,
   "rank": 3,
   "name": "대풍익",
   "slot": 180
  },
  {
   "id": "HOLY_001",
   "set": "SET5",
   "no": 181,
   "dex": null,
   "rank": 0,
   "name": "호롱이",
   "slot": 181
  },
  {
   "id": "HOLY_002",
   "set": "SET5",
   "no": 182,
   "dex": 110,
   "rank": 0,
   "name": "백호",
   "slot": 182
  },
  {
   "id": "HOLY_003",
   "set": "SET5",
   "no": 183,
   "dex": 184,
   "rank": 1,
   "name": "광휘백호",
   "slot": 183
  },
  {
   "id": "HOLY_004",
   "set": "SET5",
   "no": 184,
   "dex": 111,
   "rank": 0,
   "name": "솜파카",
   "slot": 184
  },
  {
   "id": "HOLY_005",
   "set": "SET5",
   "no": 185,
   "dex": 112,
   "rank": 0,
   "name": "알파카",
   "slot": 185
  },
  {
   "id": "HOLY_006",
   "set": "SET5",
   "no": 186,
   "dex": 185,
   "rank": 1,
   "name": "후광파카",
   "slot": 186
  },
  {
   "id": "HOLY_007",
   "set": "SET5",
   "no": 187,
   "dex": 113,
   "rank": 0,
   "name": "손모아",
   "slot": 187
  },
  {
   "id": "HOLY_008",
   "set": "SET5",
   "no": 188,
   "dex": 114,
   "rank": 0,
   "name": "여우원숭",
   "slot": 188
  },
  {
   "id": "HOLY_009",
   "set": "SET5",
   "no": 189,
   "dex": 186,
   "rank": 1,
   "name": "태양원숭",
   "slot": 189
  },
  {
   "id": "HOLY_010",
   "set": "SET5",
   "no": 190,
   "dex": 115,
   "rank": 0,
   "name": "천사치",
   "slot": 190
  },
  {
   "id": "HOLY_011",
   "set": "SET5",
   "no": 191,
   "dex": 116,
   "rank": 0,
   "name": "엔젤피시",
   "slot": 191
  },
  {
   "id": "HOLY_012",
   "set": "SET5",
   "no": 192,
   "dex": 187,
   "rank": 1,
   "name": "대천사어",
   "slot": 192
  },
  {
   "id": "HOLY_013",
   "set": "SET5",
   "no": 193,
   "dex": 117,
   "rank": 0,
   "name": "곰벌",
   "slot": 193
  },
  {
   "id": "HOLY_014",
   "set": "SET5",
   "no": 194,
   "dex": 118,
   "rank": 0,
   "name": "곰벌레",
   "slot": 194
  },
  {
   "id": "HOLY_015",
   "set": "SET5",
   "no": 195,
   "dex": 188,
   "rank": 1,
   "name": "불멸곰벌",
   "slot": 195
  },
  {
   "id": "HOLY_016",
   "set": "SET5",
   "no": 196,
   "dex": 119,
   "rank": 0,
   "name": "따옥이",
   "slot": 196
  },
  {
   "id": "HOLY_017",
   "set": "SET5",
   "no": 197,
   "dex": 120,
   "rank": 0,
   "name": "따오기",
   "slot": 197
  },
  {
   "id": "HOLY_018",
   "set": "SET5",
   "no": 198,
   "dex": 189,
   "rank": 1,
   "name": "서기따오기",
   "slot": 198
  },
  {
   "id": "HOLY_019",
   "set": "SET5",
   "no": 199,
   "dex": 121,
   "rank": 0,
   "name": "하늘애",
   "slot": 199
  },
  {
   "id": "HOLY_020",
   "set": "SET5",
   "no": 200,
   "dex": 122,
   "rank": 0,
   "name": "하늘소",
   "slot": 200
  },
  {
   "id": "HOLY_021",
   "set": "SET5",
   "no": 201,
   "dex": 190,
   "rank": 1,
   "name": "천상하늘소",
   "slot": 201
  },
  {
   "id": "HOLY_022",
   "set": "SET5",
   "no": 202,
   "dex": 123,
   "rank": 0,
   "name": "달애벌",
   "slot": 202
  },
  {
   "id": "HOLY_023",
   "set": "SET5",
   "no": 203,
   "dex": 124,
   "rank": 0,
   "name": "달나방",
   "slot": 203
  },
  {
   "id": "HOLY_024",
   "set": "SET5",
   "no": 204,
   "dex": 191,
   "rank": 1,
   "name": "만월나방",
   "slot": 204
  },
  {
   "id": "HOLY_025",
   "set": "SET5",
   "no": 205,
   "dex": 125,
   "rank": 0,
   "name": "오카핀",
   "slot": 205
  },
  {
   "id": "HOLY_026",
   "set": "SET5",
   "no": 206,
   "dex": 126,
   "rank": 0,
   "name": "오카피",
   "slot": 206
  },
  {
   "id": "HOLY_027",
   "set": "SET5",
   "no": 207,
   "dex": 192,
   "rank": 1,
   "name": "성림오카피",
   "slot": 207
  },
  {
   "id": "HOLY_028",
   "set": "SET5",
   "no": 208,
   "dex": 127,
   "rank": 0,
   "name": "까치",
   "slot": 208
  },
  {
   "id": "HOLY_029",
   "set": "SET5",
   "no": 209,
   "dex": 193,
   "rank": 1,
   "name": "길조까치",
   "slot": 209
  },
  {
   "id": "HOLY_030",
   "set": "SET5",
   "no": 210,
   "dex": 128,
   "rank": 0,
   "name": "백로",
   "slot": 210
  },
  {
   "id": "HOLY_031",
   "set": "SET5",
   "no": 211,
   "dex": 194,
   "rank": 1,
   "name": "성백로",
   "slot": 211
  },
  {
   "id": "HOLY_032",
   "set": "SET5",
   "no": 212,
   "dex": 129,
   "rank": 0,
   "name": "솜소",
   "slot": 212
  },
  {
   "id": "HOLY_033",
   "set": "SET5",
   "no": 213,
   "dex": 195,
   "rank": 1,
   "name": "구름사향소",
   "slot": 213
  },
  {
   "id": "HOLY_034",
   "set": "SET5",
   "no": 214,
   "dex": 130,
   "rank": 0,
   "name": "파수거위",
   "slot": 214
  },
  {
   "id": "HOLY_035",
   "set": "SET5",
   "no": 215,
   "dex": 131,
   "rank": 0,
   "name": "인어소",
   "slot": 215
  },
  {
   "id": "HOLY_036",
   "set": "SET5",
   "no": 216,
   "dex": 132,
   "rank": 0,
   "name": "오리너구리",
   "slot": 216
  },
  {
   "id": "HOLY_037",
   "set": "SET5",
   "no": 217,
   "dex": 133,
   "rank": 0,
   "name": "구름야크",
   "slot": 217
  },
  {
   "id": "HOLY_038",
   "set": "SET5",
   "no": 218,
   "dex": 134,
   "rank": 0,
   "name": "비단벌레",
   "slot": 218
  },
  {
   "id": "HOLY_039",
   "set": "SET5",
   "no": 219,
   "dex": 135,
   "rank": 0,
   "name": "나비고기",
   "slot": 219
  },
  {
   "id": "HOLY_040",
   "set": "SET5",
   "no": 220,
   "dex": 216,
   "rank": 2,
   "name": "호롱이",
   "slot": 220
  },
  {
   "id": "HOLY_041",
   "set": "SET5",
   "no": 221,
   "dex": 217,
   "rank": 2,
   "name": "백호",
   "slot": 221
  },
  {
   "id": "HOLY_042",
   "set": "SET5",
   "no": 222,
   "dex": 218,
   "rank": 2,
   "name": "광휘백호",
   "slot": 222
  },
  {
   "id": "HOLY_043",
   "set": "SET5",
   "no": 223,
   "dex": 219,
   "rank": 2,
   "name": "후광파카",
   "slot": 223
  },
  {
   "id": "HOLY_044",
   "set": "SET5",
   "no": 224,
   "dex": 220,
   "rank": 2,
   "name": "파수거위",
   "slot": 224
  },
  {
   "id": "HOLY_045",
   "set": "SET5",
   "no": 225,
   "dex": 225,
   "rank": 3,
   "name": "광휘백호",
   "slot": 225
  }
 ]
}
